import { InjectionToken } from "@angular/core";

export const RootScope = new InjectionToken("RootScope");

export function rootScopeServiceFactory(i: any) {
	return i.get('$rootScope');
}

export const rootScopeServiceProvider = {
	provide: RootScope,
	useFactory: rootScopeServiceFactory,
	deps: ['$injector']
};